<template>
  <v-card class="mx-auto" elevation="0">
    <v-card-title class="card-header">
      <v-row class="justify-end d-flex" dense>
        {{ $t('view') }} {{ $t('location-mapping') }}
        <v-spacer></v-spacer>
        <v-icon @click="syncronizeDrawers" class="white-icon mr-2">mdi-pencil</v-icon>
        <v-icon @click="closeDrawer" class="white-icon mr-2">mdi-close</v-icon>
      </v-row>
    </v-card-title>

    <v-card-text>
      <v-card-text class="mt-1">
        <v-row dense class="pt-0 ">
          <v-col class="text-left pl-0" cols="12">
            <v-chip pill label color="primary2" class="font-weight-bold white--text  font-size16">{{
              getSelectedLocation.ecpLocationName }}</v-chip>
          </v-col>
          <v-col class="text-left pb-0 mb-0 pl-0" cols="12">
            <span class="">{{ getSelectedLocation.medicalInstitution.institutionName }}</span>
          </v-col>
          <v-col class="text-left pt-0 mt-0 pl-0" cols="12">
            <span class="">{{ getSelectedLocation.medicalInstitution.address }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card elevation="3" class="pa-1 mx-3 mt-2 text-left" height="200">
        <span class="table-font-size ml-1">{{ getSelectedLocation.medicalInstitution.description }}</span>
      </v-card>

    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { mailPurple, phonePurple, hospitalBlack } from '@/assets';

export default {
  name: 'HospitalViewDrawer',
  components: {
  },
  data: () => ({
    manual: true,
    automatic: false,
    mailPurple: mailPurple,
    phonePurple: phonePurple,
    hospitalBlack: hospitalBlack,
    relatedHospitals: [],
    showHospitals: false,
  }),
  async mounted () {
  },
  beforeDestroy () {
    this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
  },
  computed: {
    ...mapGetters({
      getSelectedLocation: 'mapping/getSelectedLocation',
    }),
    ...mapState({
      getEcpMappingLocation: (state) => state.hospitals.getEcpMappingLocation,
      allVerifiers: (state) => state.verifiers.allverifires,
    }),
    hospitalSpecializationTitle: function () {
      const fromVerifier = this.allVerifiers.filter(v => v.rvDomain === 'HOSPITAL_SPECIALIZATION' && v.lowValue === this.selectedHospital.hospitalSpetializationId);
      if (fromVerifier == null || fromVerifier.length === 0) {
        return '';
      } else {
        return fromVerifier[0].shortDescription;
      }
    },
  },
  methods: {
    ...mapActions({
      getHospitalById: 'hospitals/getHospitalById',
    }),
    closeDrawer () {
      this.$store.commit('hospitals/SELECTED_HOSPITAL');
      this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
    },
    syncronizeDrawers () {
      // open drawer for edit
      this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
        updateDrawer: true,
        page2: '/locationMapping',
      });
    },
  },
};
</script>
